export default __webpack_public_path__ + "static/media/arrowLeft.4fe23dea.svg";